import styled from 'styled-components'

const InlineButton = styled.button<{ white?: boolean }>`
  color: ${({ white, theme }) =>
    white ? theme.colors.white : theme.colors.gray1};
  padding: 0;
`

export default InlineButton
